export const LEVELS = [4, 3, 2, 1];
export const ROWS = ["A", "B"];
export const POS = [1, 2, 3, 4];
export const locId = (code, l, r, p) => `${code}-L${l}-${r}-P${p}`;
export const isLabelComp = (n) => /label/i.test(n || "");

export const fmt = (n) => {
  if (n == null || isNaN(n)) return "0";
  const r = Math.round(n * 10) / 10;
  return Number.isInteger(r) ? r.toLocaleString() : r.toLocaleString(undefined, { maximumFractionDigits: 1 });
};

export const breakdown = (units, upc, upp) => {
  const parts = [];
  if (upp && units >= upp) parts.push(`${fmt(units / upp)} Pallet${units / upp === 1 ? "" : "s"}`);
  if (upc) parts.push(`${fmt(units / upc)} Cases`);
  parts.push(`${fmt(units)} Units`);
  return parts;
};
